import { CommonModule } from "@angular/common";
import {
  Component,
  forwardRef,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  AfterViewInit,
  Input,
  OnInit,
} from "@angular/core";
import {
  FormsModule,
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
} from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { ColorSelectorComponent } from "./color-selector.component";
import { SelectButtonModule } from "primeng/selectbutton";
import { SliderModule } from "primeng/slider";
import { InputTextareaModule } from "primeng/inputtextarea";
import { DropzoneModule, DropzoneConfigInterface } from "ngx-dropzone-wrapper";
import {
  AWSFileInformation,
  ImageUploaderModule,
  RemoteDataService,
} from "@nowinstore/nowinstore-core-ui/components";
import { HttpClient } from "@angular/common/http";
import { FILES_API_URL, SVG_MIME_TYPE, USER_API_URL } from "@app/data/const";
import { File, FileParams } from "@app/data/file";
import { User } from "@app/data/user";
import { ButtonModule } from "primeng/button";
enum SVGShape {
  RECTANGLE = "rectangle",
  CIRCLE = "circle",
  ELLIPSE = "ellipse",
  LINE = "line",
  POLYGON = "polygon",
  POLYLINE = "polyline",
  PATH = "path",
  CUSTOM = "custom",
}

@Component({
  selector: "nis-svg-editor",
  templateUrl: "./svg-editor.component.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SVGEditorComponent),
      multi: true,
    },
  ],
  imports: [
    CommonModule,
    FormsModule,
    DropdownModule,
    InputTextareaModule,
    InputNumberModule,
    ColorSelectorComponent,
    SelectButtonModule,
    SliderModule,
    DropzoneModule,
    ImageUploaderModule,
    ButtonModule,
  ],
  standalone: true,
  styles: [
    `
      :host svg {
        stroke: black;
        stroke-width: 10px;
      }
    `,
  ],
})
export class SVGEditorComponent implements ControlValueAccessor, OnInit {
  @ViewChild("preview") preview!: ElementRef;
  directory: string;

  dropzoneConfig: DropzoneConfigInterface = {
    maxFilesize: 2,
    acceptedFiles: "image/svg+xml",
  };
  svg: any = {
    stroke_width: 10,
    stroke_color: "#000000",
    fill_color: "transparent",
    html: "",
  };
  imageUploaded: any;
  @Input() brandColors: any[] = [];
  @Output() svgChange = new EventEmitter<string>();
  @ViewChild("svg") svgElement!: ElementRef;
  files: File[] = [];

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};
  originalSVG: string;

  constructor(
    private httpClient: HttpClient,
    private remoteDataService: RemoteDataService
  ) {}

  async ngOnInit() {
    var currentDate = new Date();
    const user = await this.remoteDataService.get<User>(USER_API_URL);
    this.directory =
      "media/" +
      user._id +
      "/" +
      currentDate.getFullYear() +
      "/" +
      (currentDate.getMonth() + 1) +
      "/" +
      currentDate.getDate();
    this.loadFiles();
  }

  async loadFiles() {
    this.files = await this.remoteDataService.query<File, FileParams>(
      FILES_API_URL,
      {
        mime_type: SVG_MIME_TYPE,
      }
    );
  }

  writeValue(value: any): void {
    if (value) {
      this.svg = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle disabled state if needed
  }

  // private emitSVG() {
  //   if (this.svgElement) {
  //     setTimeout(() => {
  //       const svgNode = this.svgElement.nativeElement as SVGElement;
  //       this.svgString = new XMLSerializer().serializeToString(svgNode);
  //     }, 0);
  //   }
  // }

  // parseCSV(file: any) {
  //   //read svg file and update the model
  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     const svg = e.target?.result as string;
  //     this.svg.html = svg;
  //     this.refreshSVG();
  //   };
  //   reader.readAsText(file);
  // }

  refreshSVG() {
    this.svgChange.emit(this.svg);
  }

  async onImageUploaded(fileInformation: AWSFileInformation) {
    const file = await this.remoteDataService.post<File>(FILES_API_URL, {
      url: fileInformation.url,
      name: fileInformation.name,
      mime_type: fileInformation.mime_type,
    });
    //load svg into string
    this.loadSVG(file.url);
    this.loadFiles();
  }

  loadSVG(url: string) {
    this.httpClient.get(url, { responseType: "text" }).subscribe((data) => {
      this.svg.html = data;
      this.refreshSVG();
    });
  }

  onFileSelected(file: File) {
    this.loadSVG(file.url);
  }

  async removeFile(file: File) {
    await this.remoteDataService.delete(FILES_API_URL, file._id);
    this.loadFiles();
  }
}
